<template>
    <div>
        <Pdf ref="pdf" :fileUrl="fileUrl"></Pdf>
    </div>
</template>
  
<script>
// isApplet 1是小程序跳转的
import Pdf from "@/components/Pdf.vue"

export default {
    components: {
        Pdf
    },
    data() {
        return {
            fileUrl: ""
        }
    },
    mounted() {
      
        let url=this.$route.query.name
        this.fileUrl =decodeURIComponent(url);
    
    }
}
</script>
  